<script>
/**
 * ****************************************************************************
 * @description     :   Header
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import { mapState, mapActions } from 'vuex';
import jwt_decode from 'jwt-decode';
// import helpers from '@/utils/helpers';

/**
 * import component
 */
import MainMenu from '@/shared/menu';

/**
 * import template
 */
import template from './template.html';

/**
 * Define main layout
 */
const Header = {
    name: 'Menu',
    template: template,
    components: {
        MainMenu
    },
    computed: {
        ...mapState('app', [
            'user',
            'header',
            'isShowHalfMenu',
            'isShowFullMenu',
            'messageCount',
            'isMobile',
            'isBgHeaderDefault',
            'permissions',
            'isLogout'
        ]),
        isClient() {
            try {
                var decoded = jwt_decode(localStorage.getItem('token'));
                if ((decoded.loginid + '').indexOf('@') > -1) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                console.log('isClient: ' + e.message);
                return true;
            }
        }
    },
    mounted() {
        var menuUser = document.getElementById('dropdownUser2');
        if (menuUser) {
            menuUser.classList.remove('show');
            menuUser.setAttribute('aria-expanded', 'false');
        }
    },
    methods: {
        ...mapActions('app', [
            'showHalfMenu',
            'showFullMenu',
            'hideMenu',
            'resetAppState',
            'setLogout'
        ]),
        hideMiniMenu: function () {
            if (!this.isShowFullMenu) {
                this.hideMenu();
            }
        },
        showMiniMenu: function () {
            if (!this.isShowFullMenu) {
                this.showHalfMenu();
            }
        },
        toggleFullMenu: function () {
            if (this.isShowFullMenu) {
                this.hideMenu();
            } else {
                this.showFullMenu();
            }
        },
        logout: function () {
            this.setLogout(true);
            this.$router.push('/login');
        },
        Question: function () {
            try {
                var decoded = jwt_decode(localStorage.getItem('token'));
                if ((decoded.loginid + '').indexOf('@') > -1) {
                    this.$router.push('/faq/ra400100v');
                } else {
                    this.$router.push('/faq/ra400101i');
                }
            } catch (e) {
                console.log('Question: ' + e.message);
            }
        },
        Inquiry: function () {
            this.$router.push('/faq/ra400500v');
        }
    }
};
export default Header;
</script>
